import GeneratedLogEntryStore from "./generated/GeneratedLogEntryStore"

class LogEntryStore extends GeneratedLogEntryStore {

}

export const logEntryStore = new LogEntryStore()
